import {ChangeDetectionStrategy, Component, inject, output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {OphPageHeaderComponent} from '../../shared/design/oph-page-header/oph-page-header.component';

@Component({
  selector: 'users-header',
  standalone: true,
  imports: [OphPageHeaderComponent],
  templateUrl: './users-header.component.html',
  styleUrl: './users-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersHeaderComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  searchValueChange = output<string>();

  addUser(): void {
    this.router.navigate(['new'], {relativeTo: this.activatedRoute});
  }

  onSearchChange(searchValue: string): void {
    this.searchValueChange.emit(searchValue);
  }
}
